import React from 'react'
import { observer } from 'mobx-react-lite'
import { Status } from 'shared/ui'
import { type IStatusProps } from 'shared/ui/Status'
import { type IAutomationLogExecutionStatus } from 'entities/Integrations/api/types'
import config from './config'

export const AutomationLogExecutionStatus = observer(
  ({
    status,
    emphasis = 'high',
    onlyIcon,
  }: {
    status: IAutomationLogExecutionStatus
    emphasis?: IStatusProps['emphasis']
    onlyIcon?: IStatusProps['onlyIcon']
  }) => status && <Status {...config[status]} emphasis={emphasis} onlyIcon={onlyIcon} />
)
